import { type ElementType, type FC, type ReactNode } from "react";
import * as Icons from "../Icons";
import * as Styled from "../ContractSidebarItem.styled";

type HomepageContractSidebarItemViewProps = {
    isActive: boolean;
    isDisabled: boolean;
    onClick?: () => void;
    icon: ReactNode;
    heading: ReactNode;
    subtitle: ReactNode;
    amountDisplay?: ReactNode;
    showDetailLink: boolean;
    detailLinkTo: string;
    detailLabel: string;
    linkComponent: ElementType;
};

export const HomepageContractSidebarItemView: FC<HomepageContractSidebarItemViewProps> = ({
    isActive,
    isDisabled,
    onClick,
    icon,
    heading,
    subtitle,
    amountDisplay,
    showDetailLink,
    detailLinkTo,
    detailLabel,
    linkComponent,
}) => {
    return (
        <Styled.SidebarButton isActive={isActive} onClick={isDisabled ? undefined : onClick} variant="text" disabled={isDisabled}>
            <Styled.SidebarRow>
                <Styled.SidebarContentRow>
                    {icon}
                    <div>
                        <Styled.SidebarHeading isActive={isActive} withoutScale>
                            {heading}
                        </Styled.SidebarHeading>
                        <Styled.SidebarSubtitle isActive={isActive}>{subtitle}</Styled.SidebarSubtitle>
                        {amountDisplay !== undefined && (
                            <Styled.SidebarAmount isActive={isActive} strong>
                                {amountDisplay}
                            </Styled.SidebarAmount>
                        )}
                    </div>
                </Styled.SidebarContentRow>

                {showDetailLink &&
                    (isActive ? (
                        <Styled.DetailLinkButton
                            component={linkComponent}
                            to={detailLinkTo}
                            onClick={(e: { stopPropagation: () => void }) => e.stopPropagation()}
                        >
                            {detailLabel}
                        </Styled.DetailLinkButton>
                    ) : (
                        <Styled.CaretRightIcon>
                            <Icons.CaretRight />
                        </Styled.CaretRightIcon>
                    ))}
            </Styled.SidebarRow>
        </Styled.SidebarButton>
    );
};
